// Port of api/fuel/app/classes/filter/search/games/rules/post/bgg_count_notrecommended.php
// Post rule that filters results based on community "not recommended" player count poll data.
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'bgg_count_notrecommended',
	post: function(rule, config, filter, data, results) {
		if (!results || !results.meta || !results.meta.pc) return
		if (!results.meta.count_index) return

		var countIndex = results.meta.count_index
		var filteredIndex = []
		var resultKey = results.games ? 'games' : 'index'

		var pcKeys = Object.keys(results.meta.pc)
		for (var k = 0; k < pcKeys.length; k++) {
			var id = pcKeys[k]
			var metas = results.meta.pc[id]
			if (!Array.isArray(metas)) metas = [metas]

			var passed = []

			for (var m = 0; m < metas.length; m++) {
				var pc
				try {
					pc = typeof metas[m] === 'string' ? JSON.parse(metas[m]) : metas[m]
				} catch (e) {
					continue
				}
				if (!pc) continue

				var pcEntryKeys = Object.keys(pc)
				for (var p = 0; p < pcEntryKeys.length; p++) {
					var i = pcEntryKeys[p]
					var entry = pc[i]

					if (entry.b + entry.r > entry.n) {
						var total = entry.b + entry.r + entry.n
						var percent = (100 / total) * entry.n

						if (percent <= Rule.value(rule) && rule.logic.operand === '<=') {
							passed.push(parseInt(i, 10))
						} else if (percent < Rule.value(rule) && rule.logic.operand === '<') {
							passed.push(parseInt(i, 10))
						}
					}

					if (entry.b > entry.r + entry.n) {
						passed.push(parseInt(i, 10))
					}
				}
			}

			// Check if any of the passed player counts are in the count_index
			var hasIntersection = false
			for (var c = 0; c < countIndex.length; c++) {
				if (passed.indexOf(countIndex[c]) !== -1) {
					hasIntersection = true
					break
				}
			}

			if (hasIntersection) {
				filteredIndex.push(parseInt(id, 10))
			}
		}

		// Filter results to only include items in filteredIndex
		if (results[resultKey]) {
			var preserved = []
			for (var r = 0; r < results[resultKey].length; r++) {
				if (filteredIndex.indexOf(results[resultKey][r]) !== -1) {
					preserved.push(results[resultKey][r])
				}
			}
			results[resultKey] = preserved
		}
	},
	// All logic methods are no-ops for the query phase; actual filtering is in post
	match: function(rule, config, filter, data, query) {},
	min: function(rule, config, filter, data, query) {},
	max: function(rule, config, filter, data, query) {},
	range: function(rule, config, filter, data, query) {},
	tolerance: function(rule, config, filter, data, query) {}
})
